import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createInvoice, createMeal, fetchInvoice, fetchInvoiceDetails, fetchMealsPlan, fetchMealsPlanRoom, updateInvoice, updateInvoiceStatus, } from "../../../service/api";


export const getInvoice = createAsyncThunk(
    "invoice/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchInvoice(params)
            console.log("invoice ", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getInvoiceById = createAsyncThunk(
    "invoice/getById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchInvoiceDetails(params)
            console.log("invoice info", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



// export const deleteRooms = createAsyncThunk(
//     "rooms/delete",
//     async (formValue, { rejectWithValue }) => {
//         try {
//             const response = await deleteRoom(formValue)
//             if (response.status === 201) {
//                 console.log("delete", response)
//             }
//         } catch (error) {
//             return rejectWithValue(error.response || error)
//         }
//     }
// )


export const addInvoice = createAsyncThunk(
    "invoice/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createInvoice(formValue)
            if (response.status === 201) {
                console.log("invoice", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const editInvoiceStatus = createAsyncThunk(
    "invoice/editStatus",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateInvoiceStatus(newData)
            if (response.status === 201) {
                console.log("edit status", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)



export const editInvoice = createAsyncThunk(
    "invoice/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateInvoice(newData)
            if (response.status === 201) {
                console.log("edit invocie", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)


const InvoiceSlice = createSlice({
    name: "invoices",
    initialState: {
        invoiceList: [],
        invoiceById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        status: "",
        invoiceTypes: "",
        dateKey: "issueDate",
        date: ""

    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setInvoiceStatusFilter: (state, action) => {
            state.status = action.payload;
        },
         setInvoiceTypeFilter: (state, action) => {
            state.invoiceTypes = action.payload;
        },
        setDateKeyFilter: (state, action) => {
            state.dateKey = action.payload;
        },
        setDateFilter: (state, action) => {
            state.date = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getInvoice.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getInvoice.fulfilled, (state, action) => {
                state.isLoading = false;
                state.invoiceList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })
            .addCase(getInvoice.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //by id
            .addCase(getInvoiceById.pending, (state) => {
                state.error = null
            })
            .addCase(getInvoiceById.fulfilled, (state, action) => {
                state.invoiceById = action.payload.data;
            })
            .addCase(getInvoiceById.rejected, (state, action) => {
                state.error = action.payload
            })

            // POST
            .addCase(addInvoice.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addInvoice.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addInvoice.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editInvoice.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editInvoice.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editInvoice.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
            // PUT
            .addCase(editInvoiceStatus.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editInvoiceStatus.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editInvoiceStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

        // delete
        // .addCase(deleteRooms.pending, (state, action) => {
        //     state.actionLoader = true;
        // })
        // .addCase(deleteRooms.fulfilled, (state, action) => {
        //     state.actionLoader = false;
        // })
        // .addCase(deleteRooms.rejected, (state, action) => {
        //     state.actionLoader = false;
        //     state.error = action.payload;
        // })
    }
})
export const { setSearchParams, setPagination, setDateFilter, setDateKeyFilter, setInvoiceTypeFilter,setInvoiceStatusFilter } = InvoiceSlice.actions;

export default InvoiceSlice.reducer;